import * as React from 'react';
import { memo, useContext } from 'react';
import { Card, Form, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useSearch } from '../hooks/use-search';
import Button from '/react4xp/mixins/ui/button/button';
import { ComponentContext, MobileContext } from '/react4xp/parts/knowledge-base/knowledge-base';
import { localize } from '/react4xp/mixins/helpers';

type SearchBarProps = ReturnType<typeof useSearch>;

const SearchBar = memo(({ isLoading, search, form }: SearchBarProps) => {
    const isMobile = useContext(MobileContext);
    const { translations, commonTranslations } = useContext(ComponentContext);

    return (
        <Card style={{ padding: '4%' }}>
            <Form
                form={form}
                onFinish={search}
                layout="inline"
                className="search-form"
            >
                <label className="title">{localize('label.search', translations)}</label>
                <Form.Item
                    colon={false}
                    name="query"
                    style={{ flexGrow: 100 }}
                >
                    <Input
                        prefix={<SearchOutlined style={{ color: 'gray' }} />}
                        placeholder={localize('placeholder.search', translations)}
                    />
                </Form.Item>
                {!isMobile && (
                    <Form.Item style={{ flexGrow: '1' }}>
                        <Button
                            htmlType="submit"
                            block
                            loading={isLoading}
                        >
                            {localize('button.find', commonTranslations)}
                        </Button>
                    </Form.Item>
                )}
            </Form>
        </Card>
    );
});

export default SearchBar;
